<!--礼包优惠券详情-->
<template>
  <basic-container>
    <div style="height: 80vh">
      <el-page-header @back="$router.go(-1)" content="礼包详情" />
      <div class="ac_tabs">
        <div class="ac_tabs-contain">
          <el-descriptions :column="4" size="small" border>
            <el-descriptions-item label="礼包名称">{{ info.giftName }}</el-descriptions-item>
            <el-descriptions-item label="礼包Id">{{ info.giftId }}</el-descriptions-item>
            <el-descriptions-item label="状态">{{ info.status }}</el-descriptions-item>
            <el-descriptions-item label="归属批次Id">{{ info.batchId }}</el-descriptions-item>
            <el-descriptions-item label="已绑定金额">{{ info.bindAmount }}</el-descriptions-item>
            <el-descriptions-item label="礼包数量">
              {{ info.giftNum }}
              <span style="padding-left: 10px" v-if="info.status !== '已作废'">
                <el-popover
                  placement="right"
                  width="250"
                  trigger="click"
                  v-if="info.split !== '是'"
                >
                  <el-form :model="form" size="mini" :inline="true">
                    <el-form-item>
                      <el-input v-model="form.num" clearable style="width: 8vw" />
                    </el-form-item>
                    <el-form-item>
                      <el-button type="success" @click.stop="submit">确定</el-button>
                    </el-form-item>
                  </el-form>
                  <el-button
                    type="primary"
                    slot="reference"
                    size="mini"
                    v-has-permi="['coupon_add_more']"
                    >增发</el-button
                  >
                </el-popover>
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="礼包剩余数量">{{ info.remainNum }}</el-descriptions-item>
            <el-descriptions-item label="创建人">{{ info.creatUser }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ info.creatTime }}</el-descriptions-item>
            <el-descriptions-item label="内部优惠券是否可拆分">{{
              info.split
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>

      <div class="ac_tabs" style="height: 80%">
        <div class="ac_tabs_nav-wrap">
          <div class="ac_tabs-items">
            <span>优惠券</span>
            <span style="padding-left: 20px" v-if="info.status !== '已作废'">
              <el-button
                type="success"
                size="mini"
                icon="el-icon-plus"
                v-has-permi="['coupon_add']"
                @click="handleCouponCreate"
                >创建优惠券</el-button
              ></span
            >
          </div>
        </div>
        <div class="ac_tabs-contain" style="height: 78%">
          <yd-table
            :loading="loading"
            :data="data"
            size="mini"
            :pagination="page"
            height="450px"
            @onChange="onTableChange"
          >
            <el-table-column label="优惠券ID" width="150" prop="couponId" />
            <el-table-column label="优惠券名称" prop="couponName" width="150">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="handlePkgView(scope.row.couponId)"
                  >{{ scope.row.couponName }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="面值" prop="faceValue" width="60" />
            <el-table-column label="总量" prop="remainNum" width="88" />
            <el-table-column label="有效期" prop="validDate" width="180" />
            <el-table-column label="可用业务" prop="bu" />
            <el-table-column label="可用范围" width="200">
              <template slot-scope="scope">
                <div class="range-text">{{
                  Array.isArray(scope.row.range) ? scope.row.range.join(';') : ''
                }}</div>
                <el-button
                  v-if="Array.isArray(scope.row.range) && scope.row.range.length > 4"
                  type="text"
                  size="mini"
                  @click="moreRange(scope.row.range)"
                  >查看更多</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="创建人" prop="creatName" width="100" />
            <el-table-column label="创建时间" prop="creatTime" width="180" />
            <el-table-column label="状态" prop="state" width="88" />
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <span
                  style="padding-right: 10px"
                  v-if="scope.row.stateCode !== 3 || scope.row.stateCode === 2"
                >
                  <el-popover
                    placement="bottom"
                    :title="`增发 【${scope.row.couponName}】 优惠券`"
                    width="280"
                    trigger="click"
                  >
                    <el-form :model="form" :inline="true">
                      <el-form-item>
                        <avue-input-number
                          v-model="form.couponNum"
                          size="mini"
                          clearable
                          minRows="0"
                          style="width: 8vw"
                        />
                      </el-form-item>
                      <el-form-item>
                        <el-button
                          type="primary"
                          size="mini"
                          @click.stop="handleNewAddCoup(scope.row.couponId)"
                          >确定</el-button
                        >
                      </el-form-item>
                    </el-form>
                    <el-button
                      type="text"
                      slot="reference"
                      size="mini"
                      v-has-permi="['coupon_add_more']"
                      >增发</el-button
                    >
                  </el-popover>
                </span>

                <el-button
                  size="mini"
                  v-if="scope.row.stateCode !== 3"
                  type="text"
                  v-has-permi="['coupon_delete']"
                  @click.stop="handleZuofei(scope.row.couponId)"
                  >作废</el-button
                >

                <el-button
                  size="mini"
                  type="text"
                  @click.stop="handlePkgDataView(scope.row.couponId)"
                  >数据</el-button
                >
              </template>
            </el-table-column>
          </yd-table>
          <!-- <pagination
            :total="page.total"
            :page.sync="page.current"
            :limit.sync="page.size"
            @pagination="onLoad"
          /> -->
        </div>
      </div>
    </div>

    <el-dialog
      title="可用范围"
      :visible.sync="moreVisible"
      :append-to-body="true"
      width="50%"
      before-close="closeMoreRange"
    >
      <div class="range-box">
        <div v-for="(item, index) in this.range" :key="index">
          <span style="padding-left: 15px">{{ item }}</span>
        </div>
      </div>
    </el-dialog>
    <!--新增优惠券-->
    <coupon-pkg-create ref="couponCreate" @refreshDetailsList="onLoad" />

    <pkg-view ref="pkgView" v-if="pkgViewVisible" @refreshDataList="onLoad" />
    <pkg-data-view ref="pkgDataView" v-if="pkgDataViewVisible" />
  </basic-container>
</template>

<script>
  import CouponPkgCreate from '../components/coupon/coupon-pkg-add'
  import PkgView from '../components/coupon/coupon-pkg-details'
  import PkgDataView from '../components/coupon/coupon-pkgdata-view'

  import {
    getCPkgDetails,
    addPkgNum,
    listCouponPageByGiftId,
    zuofei,
    newAddCoupons,
    getPkgDetails
  } from '@/api/marketing/coupon-api'
  export default {
    name: 'couponDetails',
    components: {
      CouponPkgCreate,
      PkgView,
      PkgDataView
    },
    data() {
      return {
        loading: false,
        addCpVisible: false,
        pkgViewVisible: false,
        pkgDataViewVisible: false,
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        form: {},
        cpform: {},
        info: {},
        batchInfo: {}, // 批次信息
        data: [],
        moreVisible: false,
        range: []
      }
    },
    created() {
      this.info.giftId = this.$route.query.cpId
      this.batchInfo.batchId = this.$route.query.batchId
      this.getDetails()
      // this.onLoad()
    },
    methods: {
      onTableChange({ current, pageSize }) {
        this.page.current = current
        this.page.size = pageSize
        this.onLoad()
      },
      handleCouponCreate() {
        this.$refs.couponCreate.init(this.info, this.batchInfo)
      },
      async getDetails() {
        await getCPkgDetails(this.info.giftId).then((resp) => {
          this.info = resp.data
        })
        await getPkgDetails(this.batchInfo.batchId).then((resp) => {
          this.batchInfo = resp.data
        })
      },
      // 加载数据
      async onLoad() {
        this.loading = true
        const adonData = {
          giftId: this.info.giftId,
          current: this.page.current,
          size: this.page.size
        }
        listCouponPageByGiftId(adonData).then((resp) => {
          this.data = resp.data.records || []
          this.page.total = resp.data.total
          this.loading = false
        })
      },
      handlePkgView(id) {
        this.pkgViewVisible = true
        this.$nextTick(() => {
          this.$refs.pkgView.init(id)
        })
      },

      handlePkgDataView(id) {
        this.pkgDataViewVisible = true
        this.$nextTick(() => {
          this.$refs.pkgDataView.init(id)
        })
      },
      // 新增数量
      submit() {
        addPkgNum({ num: this.form.num, giftId: this.info.giftId }).then((resp) => {
          if (resp.code === 0) {
            this.$message.success('添加成功')
            this.form.num = null
            this.getDetails()
          }
        })
      },
      handleZuofei(coupId) {
        this.$confirm('确定将该优惠券作废吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            return zuofei(coupId)
          })
          .then(() => {
            this.onLoad()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          })
      },
      handleNewAddCoup(coupId) {
        this.form.couponId = coupId
        newAddCoupons(this.form).then((resp) => {
          if (resp.code === 0) {
            this.form.couponNum = ''
            this.onLoad()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.addCpVisible = false
          }
        })
      },
      moreRange(range) {
        this.range = range
        this.moreVisible = true
      },
      closeMoreRange() {
        this.range = []
        this.moreVisible = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ac_tabs {
    padding: 10px 10px;
    box-sizing: border-box;
  }
  .ac_tabs_nav-wrap {
    overflow: hidden;
    margin-bottom: -1px;
    position: relative;
  }
  .ac_tabs_nav-wrap:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #e4e7ed;
    z-index: 1;
  }
  .ac_tabs-items {
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    position: relative;
  }
  .ac_tabs-contain {
    padding: 10px 0 0 0;
  }
  .range-box {
    height: 350px;
    width: 95%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  .range-text {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
